import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useEmergencyCreditsConfig() {
  const emergencyCreditsConfig = useCbhFlag(CbhFeatureFlag.EMERGENCY_CREDITS_CONFIG, {
    defaultValue: { enabled: false },
  });

  return emergencyCreditsConfig;
}
